<template>
  <div class="freezerDetail">
    <FixedButton class="myFixed">
      <el-button type="primary" plain @click="handleOpen" :disabled="info.online === 'offline'"
        >远程启停</el-button
      >
      <el-button type="primary" @click="handleSetParam" :disabled="info.online === 'offline'"
        >参数设置</el-button
      >
    </FixedButton>
    <div class="wrap">
      <div class="assetNumber">{{ info.assetNumber | formatStr }}</div>
      <div
        class="lineStatus"
        :class="{ online: info.online === 'online', offline: info.online === 'offline' }"
        v-if="info.online"
      >
        {{ info.onlineStr }}
      </div>
      <div class="clearfix"></div>
      <div class="address">
        <i class="iconfont icon-address" style="margin-right: 8px; color: #a7a3a1;"></i
        >{{ info.locationAddress | formatStr }}
      </div>
      <el-row :gutter="20">
        <el-col :span="8">
          <ContentBlock class="block" title="设备型号" :value="info.productModel | formatStr" />
          <ContentBlock class="block" title="ICCID" :value="info.iccid | formatStr" />
          <ContentBlock class="block" title="模块IMEI号" :value="info.imei | formatStr" />
        </el-col>
        <el-col :span="8">
          <ContentBlock class="block" title="大客户" :value="info.customerName | formatStr" />
          <ContentBlock class="block" title="联系人" :value="info.contacts | formatStr" />
          <ContentBlock class="block" title="联系电话" :value="info.phone | formatStr" />
        </el-col>
        <div class="refDiv" v-if="info.room === 2">
          <div class="temp" v-if="info.state === 'normal'">{{ info.refTemp | formatStr }}℃</div>
          <div class="temp" v-else>--</div>
          <div class="title">冷藏温度</div>
        </div>
        <div class="freDiv" v-if="info.room === 2">
          <div class="temp" v-if="info.state === 'normal'">{{ info.freTemp | formatStr }}℃</div>
          <div class="temp" v-else>--</div>
          <div class="title">冷冻温度</div>
        </div>
        <div class="singleDiv" v-if="info.room === 1">
          <div class="temp" v-if="info.state === 'normal'">{{ info.refTemp | formatStr }}℃</div>
          <div class="temp" v-else>--</div>
          <div class="title">间室温度</div>
        </div>
      </el-row>
      <el-row :gutter="20" style="margin-top: 16px;">
        <el-col :span="16">
          <ContentBlock class="block" title="历史IMEI号" :value="info.imeiHistory | formatStr" />
        </el-col>
      </el-row>
      <div class="infoTitle">详情信息</div>
      <ContentBlock
        class="block item"
        :title="item.name + (item.specs.unit ? '(' + item.specs.unit + ')' : '')"
        :value="
          (info.shadow
            ? item.dataType === 'enum'
              ? item.specs.enumDesc[info.shadow[item.identifier]]
              : info.shadow[item.identifier]
            : null) | formatStr
        "
        v-for="(item, index) in deviceAttr"
        :key="index"
      />
      <div class="clearfix"></div>
    </div>
    <div class="wrap">
      <el-tabs v-model="dataType" @tab-click="handleClickTab">
        <el-tab-pane label="温度变化" name="temperature" lazy>
          <Temperature ref="temperature" :id="id" :room="room"></Temperature>
        </el-tab-pane>
        <el-tab-pane label="预警记录" name="alarm1">
          <Alarm ref="alarm1" :assetNumber="assetNumber" excType="01"></Alarm>
        </el-tab-pane>
        <el-tab-pane label="故障记录" name="alarm2">
          <Alarm ref="alarm2" :assetNumber="assetNumber" excType="02"></Alarm>
        </el-tab-pane>
      </el-tabs>
    </div>
    <Dialog
      :detail="true"
      :ids="id"
      :assetId="assetId"
      @getDetail="getDetail"
      v-if="showModal"
      :visible.sync="showModal"
    ></Dialog>
    <Open
      :detail="true"
      :ids="id"
      :assetId="assetId"
      @getDetail="getDetail"
      v-if="showOpenModal"
      :visible.sync="showOpenModal"
    ></Open>
  </div>
</template>

<script>
import ContentBlock from '@manage/components/ContentBlock/index'
import { format } from '@manage/utils/utils'
import Temperature from './temperature'
import Alarm from './alarm'
import Dialog from './param'
import Open from './open'

export default {
  name: 'FreezerDetail',
  data() {
    return {
      id: '',
      assetNumber: '',
      room: '',
      assetId: '',
      info: {},
      deviceAttr: [],
      dataType: 'temperature',
      imei: '',
      positionAlarm: '',
      imageList: [],
      showModal: false,
      showOpenModal: false
    }
  },
  computed: {
    accountType() {
      return this.$store.state.accountType
    }
  },
  mounted() {
    // 冷柜ID
    this.id = this.$route.query.id
    // SN
    this.assetNumber = this.$route.query.assetNumber
    // 间室
    this.room = this.$route.query.room
    // 设备型号
    this.assetId = this.$route.query.assetId

    // 获取设备属性
    this.getDeviceAttr()
    // 获取详情数据
    this.getDetail()
  },
  filters: {
    formatStr(str) {
      return format(str)
    }
  },
  methods: {
    getDetail() {
      const params = {
        id: this.id
      }

      this.$ajax.get(this.$api.freezer.device_detail, params).then((res) => {
        this.info = { ...res.data }
      })
    },
    getDeviceAttr() {
      const params = {
        id: this.id
      }

      this.$ajax.get(this.$api.freezer.device_properties, params).then((res) => {
        this.deviceAttr = res.data
      })
    },
    handleSetParam() {
      this.showModal = true
    },
    handleOpen() {
      this.showOpenModal = true
    },
    handleClickTab(target) {
      if (target.name === 'temperature') {
        this.$refs.temperature.getAutoTemperature(1)
      }
      if (target.name === 'alarm1') {
        this.$refs.alarm1.formSearch()
      }
      if (target.name === 'alarm2') {
        this.$refs.alarm2.formSearch()
      }
    }
  },
  components: {
    ContentBlock,
    Temperature,
    Alarm,
    Dialog,
    Open
  }
}
</script>

<style lang="less" scoped>
.freezerDetail {
  position: relative;
  width: 100%;
  .myFixed {
    top: -54px;
    right: 0;
  }
  .wrap {
    margin-top: 24px;
    margin-bottom: 24px;
    padding: 24px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    .assetNumber {
      margin-right: 16px;
      float: left;
      line-height: 33px;
      font-size: 24px;
      font-weight: bold;
      color: #231815;
    }
    .lineStatus {
      margin-top: 6px;
      float: left;
      padding: 4px;
      font-size: 12px;
      color: #ffffff;
      border-radius: 2px;
      &.online {
        background: #539cff;
      }
      &.offline {
        background: #a8abb0;
      }
    }
    .address {
      margin-top: 8px;
      margin-bottom: 24px;
      line-height: 20px;
      font-size: 14px;
      font-weight: bold;
      color: #231815;
    }
    .el-row {
      position: relative;
      .refDiv {
        position: absolute;
        top: 0;
        right: 194px;
        padding-top: 21px;
        width: 146px;
        height: 96px;
        background-image: url('../../../assets/Temperature_bg1.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        border: 1px solid rgba(233, 231, 231, 0.5);
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        .title {
          line-height: 14px;
          font-size: 14px;
          color: #655d5b;
          letter-spacing: 0;
          text-align: center;
        }
      }
      .freDiv {
        position: absolute;
        top: 0;
        right: 14px;
        padding-top: 21px;
        width: 146px;
        height: 96px;
        background-image: url('../../../assets/Temperature_bg2.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        border: 1px solid rgba(233, 231, 231, 0.5);
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        .title {
          line-height: 14px;
          font-size: 14px;
          color: #655d5b;
          letter-spacing: 0;
          text-align: center;
        }
      }
      .singleDiv {
        position: absolute;
        top: 0;
        right: 14px;
        padding-top: 21px;
        width: 315px;
        height: 96px;
        background-image: url('../../../assets/Temperature_bg3.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        border: 1px solid rgba(233, 231, 231, 0.5);
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        .title {
          line-height: 14px;
          font-size: 14px;
          color: #655d5b;
          letter-spacing: 0;
          text-align: center;
        }
      }
      .temp {
        line-height: 36px;
        font-family: Number-Bold;
        font-size: 36px;
        font-weight: bold;
        color: #333333;
        letter-spacing: 0;
        text-align: center;
      }
    }
    .infoTitle {
      margin-top: 48px;
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: bold;
      color: #231815;
    }
    .block {
      margin-top: 16px;
      &:first-child {
        margin-top: 0;
      }
      &.item {
        float: left;
        width: 33.3%;
      }
    }
    /deep/ .el-tabs {
      .el-tabs__nav-wrap {
        padding-top: 8px;
        padding-left: 24px;
      }
      .el-tab-pane {
        padding: 9px 24px 24px;
      }
      .image {
        display: block;
        margin: 0 auto;
        width: 600px;
        height: 600px;
        .image-slot {
          display: flex;
          width: 100%;
          height: 100%;
          font-size: 60px;
          color: #909399;
          background: #f5f7fa;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
</style>
